import Swiper from "swiper";
import "lightgallery.js";
import "lg-video.js";
import "lg-thumbnail.js";

const {lightGallery} = window;


var init = function () {
  var sliderOpt = {
    slidesPerView: 3,
    threshold: 50,
    spaceBetween: 26,
    updateOnWindowResize: true,
    updateOnImagesReady: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".pdp-media-gallery-slider__nav--next",
      prevEl: ".pdp-media-gallery-slider__nav--prev",
      disabledClass: "pdp-media-gallery-slider__nav--disabled"
    },
    breakpoints: {
      992: {
        slidesPerView: 2.4,
      },
      720: {
        slidesPerView: 1.2,
      },
    }
  };
  var getEmptySlideObserver = (function(){
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

    return function( obj, callback ){
      if( !obj || obj.nodeType !== 1 ) return;

      if( MutationObserver ){
        var mutationObserver = new MutationObserver(callback)
        mutationObserver.observe( obj, { childList:true, subtree:true })
        return mutationObserver
      }

      // browser support fallback
      else if( window.addEventListener ){
        obj.addEventListener('DOMNodeRemoved', callback, false)
      }
    }
  })();
  var getCallback = function(parent){
    var p=parent;
    return function (m) {
      var removedNodes = [];
      m.forEach(record => record.removedNodes.length & removedNodes.push(...record.removedNodes))
      if (removedNodes.length>0 && !!p.querySelector('.no-slides-found') && p.querySelectorAll('.swiper-slide').length<1) {
        p.querySelector('.no-slides-found').classList.remove('hidden');
      }
    }
  }
  var mediaGallerySliders = document.querySelectorAll('.pdp-media-gallery-slider');
  if (mediaGallerySliders.length > 0) {
    new Swiper('.pdp-media-gallery-slider', sliderOpt);

    for (var i = 0; i < mediaGallerySliders.length; i++) {
      if (
        !!mediaGallerySliders[i].querySelector('.swiper-slide') &&
        mediaGallerySliders[i].querySelector('.swiper-slide').children.length>0
      ) {
        lightGallery(mediaGallerySliders[i], {
          selector: ".swiper-slide",
          thumbnail: true,
          download: false,
          addClass: "pdp-media-lightgallery"
        });

        getEmptySlideObserver(mediaGallerySliders[i], getCallback(mediaGallerySliders[i]));
      }
    }
  }


};
export default {init};
